
import type { PropOptions } from 'vue';
import Vue from 'vue';
import TrashIcon from '@/assets/svg/trash-opaque.vue.svg';
import HamburgerIcon from '@/assets/svg/hamburger.vue.svg';
import BravadoIconButton from '~/components/common/BravadoIconButton/BravadoIconButton.vue';

export default Vue.extend({
  name: 'VerifiedTestimonial',
  components: { BravadoIconButton, TrashIcon, HamburgerIcon },
  props: {
    avatar: {
      type: String,
      default: '',
    } as PropOptions<string>,
    authorName: {
      type: String,
      default: '',
    } as PropOptions<string>,
    authorPosition: {
      type: String,
      default: '',
    } as PropOptions<string>,
    testimonial: {
      type: String,
      default: '',
    } as PropOptions<string>,
    state: {
      type: String,
      required: true,
    } as PropOptions<'verified' | 'archiving'>,
  },
  computed: {
    avatarClass(): Record<string, boolean> {
      return {
        'verified-testimonial__avatar': true,
        'verified-testimonial__avatar--archived': this.isArchiving,
      };
    },
    isArchiving(): boolean {
      return this.state === 'archiving';
    },
  },
});
